import React from "react";
import PropTypes from "prop-types";
import Typography from "@mui/material/Typography";
import {
  LABOR,
  SALES,
  INVENTORY_CONTROL,
  SERVICES,
  BALLOONS,
  OMNI_CHANNEL,
} from "../../common/constants";
import "./styles.scss";

const SummaryCard = ({
  title,
  children,
  primaryLocationName,
  selectedDateMatrix,
  handleLaborCardClick,
  handleSalesCardClick,
  handleInventoryControlCardClick,
  handleOmniChannelCardClick,
  handleServicesCardClick,
}) => {
  const handleClick = () => {
    switch (title) {
      case SALES:
        handleSalesCardClick();
        break;
      case SERVICES:
      case BALLOONS:
        handleServicesCardClick();
        break;
      case OMNI_CHANNEL:
        handleOmniChannelCardClick();
        break;
      case LABOR:
        handleLaborCardClick();
        break;
      case INVENTORY_CONTROL:
        handleInventoryControlCardClick();
        break;
      default:
        break;
    }
  };

  return (
    <div data-testid="summary-card" className="summary-card">
      <Typography
        color="primary"
        component="h6"
        variant="h6"
        className="title-row"
        onClick={handleClick}
        style={{
          textDecoration: "underline",
          width: "fit-content",
          textUnderlinePosition: "under",
           cursor: 'pointer',
          //  cursor: title === INVENTORY_CONTROL ? 'default' : 'pointer',
        }}
      >
        {title}
      </Typography>

      {}
      {children}
    </div>
  );
};

SummaryCard.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node,
  primaryLocationName: PropTypes.string,
  selectedDateMatrix: PropTypes.string,
  handleLaborCardClick: PropTypes.func,
  handleSalesCardClick: PropTypes.func,
  handleInventoryControlCardClick: PropTypes.func,
  handleOmniChannelCardClick: PropTypes.func,
  handleServicesCardClick: PropTypes.func,
};

export default SummaryCard;
